// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2psRz","title":"Header_title__X1Tq-","side":"Header_side__2anBP"};